goog.provide("shadow.js.shim.module$src$svg$location$poi_svg");
goog.provide("module$shadow_js_shim_module$src$svg$location$poi_svg");
shadow.js.shim.module$src$svg$location$poi_svg = shadow.js.nativeProvides["src/svg/location/poi.svg"] = shadow$bridge("src/svg/location/poi.svg");
module$shadow_js_shim_module$src$svg$location$poi_svg.default = shadow.js.shim.module$src$svg$location$poi_svg;
